import React from 'react';
import { Edit } from 'react-admin';

import UserForm from '../UserForm';

function UserEdit(props) {
  return (
    <Edit {...props} title="Editar usuario" undoable={false}>
      <UserForm />
    </Edit>
  );
}

export default UserEdit;
